import { SettingsOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Navigation } from "./navigation/navigation";

export const Setting = () => {
  // const navigate = useNavigate();
  // useEffect(() => {
  //   navigate("user");
  // }, [navigate]);
  return (
    <Stack
      direction={"row"}
      sx={{ width: "100%", height: "100%", padding: "0 2px" }}
    >
      <Stack spacing={1}>
        <Stack
          direction={"row"}
          justifyContent={"center"}
          spacing={1}
          alignItems={"center"}
        >
          <SettingsOutlined fontSize="small"></SettingsOutlined>
          <Typography
            variant="body2"
            textAlign={"center"}
            textTransform={"capitalize"}
            fontWeight={(theme) => theme.typography.fontWeightMedium}
          >
            Cài đặt hệ thống
          </Typography>
        </Stack>

        <Navigation></Navigation>
      </Stack>

      <Stack flex={1}>
        <Outlet />
      </Stack>
    </Stack>
  );
};
